import { IProjectRecipeDTO } from 'data/dtos/automation/i-project-dto'

export const isDisabledButtonPlayStatus = (recipe: IProjectRecipeDTO, recipes: IProjectRecipeDTO[], index: number) => {
  let isDisabled = false

  const isInProcess = recipes.find((recipe: any) => recipe.status == 'running')

  if (isInProcess != null && isInProcess.status != recipe.status) {
    isDisabled = true
  }

  const previusRecipe = recipes[index - 1]

  if (previusRecipe != null && previusRecipe.status != 'success') {
    isDisabled = true
  }

  if (recipe.status == 'running') {
    isDisabled = true
  }

  if (recipe.status == 'block') {
    isDisabled = true
  }

  if (!recipe.isAllowed) {
    isDisabled = true
  }

  if (previusRecipe != null && previusRecipe.appName == 'Multipla escolha') {
    isDisabled = false
  }

  return isDisabled
}
